// **************** ROUTE CONSTANT START **************************
// General Page Section

export const LANDING_PAGE = "/";
export const FORMPRIZE = "/contact";
export const FORMCONFIRM = "/form-confirm";
// export const SUCCESSFORM = '/thanks'
export const SUCCESSFORM = "/thanks";
export const LOTTERY = "/lottery";
// **************** ROUTE CONSTANT END **************************

export const CURRENCY = "$";
